'use client';

import Link from '@eliadmin/core/src/components/link';
import React from 'react';

import type {
  GeneralLayout,
  Menu,
} from '@eliadmin/core/src/api/general/types/general-layout-types';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { getSafeHref } from '@eliadmin/core/src/utils/url-utils';
import { FiPhoneCall } from 'react-icons/fi';

export type TopbarProps = {
  locale?: string;
  generalLayout: GeneralLayout['data'];
  menu: Menu;
};

export function Topbar({ generalLayout, menu }: TopbarProps) {
  const { t } = useTranslations();

  return (
    <div
      className={cn(
        'custom-section',
        'relative z-30 hidden h-[52px] border-b border-b-border bg-white md:flex',
        'ea-header-main__topbar-section',
      )}
    >
      <div className={cn('custom-container--xxl', 'hidden items-center justify-between sm:flex')}>
        <div className="flex items-center justify-start gap-4 lg:gap-6">
          {menu.fields.map(field => (
            <Link
              key={field.name}
              href={getSafeHref(field?.path ?? '#')}
              prefetch={false}
              className="text-sm tracking-tight transition-all hover:opacity-75 lg:text-base"
            >
              {field.name}
            </Link>
          ))}
        </div>
        <div className="flex items-center justify-end gap-2">
          <p className="hidden lg:block">{t('text3438')}:</p>
          <Link
            prefetch={false}
            href={`tel:${generalLayout?.contact?.phone}`}
            target="_blank"
            className="flex items-center justify-end gap-2 text-sm transition-all hover:opacity-80 lg:text-base"
          >
            <FiPhoneCall className="max-h-4 min-h-4 min-w-4 max-w-4 lg:max-h-5 lg:min-h-5 lg:min-w-5 lg:max-w-5" />
            {generalLayout?.contact?.phone}
          </Link>
        </div>
      </div>
    </div>
  );
}
